enum PageUrl {
  HOME = '/',
  HEALTH = '/health'
}

export default PageUrl;
